export const languageData = {
	el: {
		app: {
			version: "Έκδοση εφαρμογής",
		},
		cookieConsent: {
			manageCookies: "Διαχείριση Cookies",
		},
		player: {
			next_episode_in: "Επόμενο επεισόδιο σε",
			play_next_now: "Προβολή επόμενου επεισόδιου",
			error_generic: "Παρουσιάστηκε σφάλμα κατά την αναπαραγωγή. Παρακαλούμε δοκιμάστε ξανά αργότερα.",
		},
		playback: {
			maxStreamsReached:
				"Έχετε φτάσει το όριο ταυτόχρονων αναπαραγωγών ({max}). Παρακαλούμε σταματήστε την αναπαραγωγή σε άλλη συσκευή για να συνεχίσετε.",
			errorStarting: "Αδυναμία έναρξης αναπαραγωγής. Παρακαλούμε δοκιμάστε ξανά.",
		},
		generic: {
			movie: "Ταινία",
			series: "Σειρά",
			movies: "Ταινίες",
		},
		contact: {
			title: "Φόρμα Επικοινωνίας",
			field_title: "Θέμα",
			field_message: "Μήνυμα",
			submit: "Υποβολή",
			success_message: "Το μήνυμά σας στάλθηκε επιτυχώς. Ευχαριστούμε για την επικοινωνία!",
			error_message: "Παρουσιάστηκε σφάλμα κατά την αποστολή του μηνύματός σας. Παρακαλούμε δοκιμάστε ξανά αργότερα.",
		},
		header: {
			frontpage: "Αρχική",
			movies: "Ταινίες",
			series: "Σειρές",
			categories: "Κατηγορίες",
			menu: "Μενού",
			languageSelector: "Επιλογή γλώσσας",
			langswitcher: "Αλλαγή γλώσσας",
		},
		profile: {
			select: "Επιλογή προφίλ",
			greeting: "Γεια σου",
			myProfile: "Το προφίλ μου",
			myAccount: "Ο λογαριασμός μου",
			title: "Προφίλ",
			name: "Όνομα προφιλ",
			create: "Δημιουργία νέου προφιλ",
			choose_profile: "Διαλέξτε το προφιλ σας",
			choose_icon: "Διαλέξτε την εικόνα προφιλ σας",
			login: "Σύνδεση",
			logout: "Αποσύνδεση",
			register: "ΕΓΓΡΑΦΗ",
			edit: "Επεξεργασία προφίλ",
			change_icon: "Αλλαγή εικόνας προφιλ",
			success: "Η εγγραφή του προφίλ έγινε επιτυχώς",
			save: "Αποθήκευση προφίλ",
			saving: "Αποθήκευση...",
			add_profile: "Προσθήκη προφίλ",
			loginnow: "Συνδεθείτε τώρα",
			login_basic: "Σύνδεση",
			manageDevices: "Διαχείριση Συσκευών",
			noActiveSubscription: "Δεν βρέθηκε ενεργή συνδρομή",
		},
		devices: {
			title: "Οι Συσκευές Μου",
			subtitle: "Μπορείτε να έχετε έως και {max} ενεργές συσκευές",
			noDevices: "Δεν έχετε καμία εγγεγραμμένη συσκευή",
			deviceId: "Αναγνωριστικό συσκευής",
			lastActive: "Τελευταία δραστηριότητα",
			registered: "Εγγεγραμμένο",
			currentDevice: "Τρέχουσα συσκευή",
			remove: "Αφαίρεση",
			confirmRemoveTitle: "Επιβεβαίωση Αφαίρεσης",
			confirmRemove: "Είστε σίγουροι ότι θέλετε να αφαιρέσετε αυτήν τη συσκευή;",
			confirmRemoveButton: "Αφαίρεση",
			cancel: "Ακύρωση",
			registerThisDevice: "Εγγραφή αυτής της συσκευής",
			deviceLimitReached:
				"Έχετε φτάσει το όριο συσκευών. Αφαιρέστε μία συσκευή για να συνεχίσετε να προβάλλετε περιεχόμενο σε αυτήν τη συσκευή.",
		},
		teaser: {
			see_more: "Δείτε περισσότερα",
		},
		search: {
			placeholder: "Αναζήτηση...",
			no_results: "Δεν βρέθηκαν αποτελέσματα",
			search_with: "Αποτελέσματα αναζήτησης για",
			search_tooltip: "Αναζήτηση",
		},
		innerpage: {
			continue: "ΣΥΝΕΧΕΙΑ",
			play: "ΠΡΟΒΟΛΗ",
			added: "Προστέθηκε!",
			removed: "Αφαιρέθηκε!",
			cast: "Καστ",
			season: "Σεζόν ",
			type: "Είδη",
			movie_characteristics: "Χαρακτηριστικά ταινίας",
			series_characteristics: "Χαρακτηριστικά σειράς",
			more_like_that: "Κι άλλα σαν αυτό",
			episodes: "Επεισόδια",
			filter_by_season: "Φιλτράρισμα ανά σεζόν",
		},
		noConnection: "Χωρίς σύνδεση στο διαδίκτυο",
		noConnectionDescription: "Παρακαλούμε ελέγξτε τη σύνδεσή σας και προσπαθήστε ξανά.",
		promo: {
			title: "Μοναδικές ταινίες και σειρές",
			subtitle: "Μόνο με 9.90€ ανά μήνα βλέπετε όλο μας το περιεχόμενο",
			cancel_anytime: "Ακύρωση οποιαδήποτε στιγμή",
			start_button: "Ξεκινήστε τώρα",
		},
		mobilelogin: {
			loginnow: "Συνδεθείτε τώρα για να αποκτήσετε πρόσβαση στο περιεχόμενο.",
			enter: "Είσοδος",
		},
		notfound: {
			page_title: "Η σελίδα δεν βρέθηκε | Valor Movies",
			title: "Η σελίδα δεν βρέθηκε",
			message: "Λυπούμαστε, η σελίδα που ψάχνετε δεν υπάρχει ή έχει μετακινηθεί.",
			back_home: "Επιστροφή στην Αρχική",
		},
		pager: {
			next: "Επόμενη",
			prev: "Προηγούμενη",
			page: "Σελίδα",
		},
		support: {
			title: "Υποστήριξη",
			body: "Εάν χρειάζεστε βοήθεια, παρακαλούμε επικοινωνήστε με την ομάδα υποστήριξής μας στο {email}, ή επικοινωνήστε μαζί μας μέσω της φόρμας υποστήριξης.",
		},
	},
	en: {
		pager: {
			next: "Next",
			prev: "Previous",
			page: "Page",
		},
		app: {
			version: "App Version",
		},
		player: {
			next_episode_in: "Next episode in",
			play_next_now: "Play next episode now",
			error_generic: "An error occurred during playback. Please try again later.",
		},
		playback: {
			maxStreamsReached:
				"You have reached the maximum concurrent streams limit ({max}). Please stop playback on another device to continue.",
			errorStarting: "Failed to start playback. Please try again.",
		},
		generic: {
			movie: "Movie",
			series: "Series",
			movies: "Movies",
		},
		contact: {
			title: "Contact Form",
			field_title: "Subject",
			field_message: "Message",
			submit: "Submit",
			success_message: "Your message has been sent successfully. Thank you for contacting us!",
			error_message: "An error occurred while sending your message. Please try again later.",
		},
		header: {
			frontpage: "Home",
			movies: "Movies",
			series: "Series",
			categories: "Categories",
			menu: "Menu",
			languageSelector: "Select Language",
			langswitcher: "Change Language",
		},
		profile: {
			select: "Select Profile",
			title: "Profile",
			myProfile: "My Profile",
			greeting: "Hello",
			name: "Profile name",
			myAccount: "My Account",
			create: "Create new profile",
			choose_profile: "Choose your profile",
			choose_icon: "Choose your profile icon",
			login: "Login",
			logout: "Logout",
			register: "REGISTER",
			edit: "Edit profile",
			change_icon: "Change your profile icon",
			success: "Profile registerd successfully",
			save: "Save profile",
			saving: "Saving...",
			add_profile: "Add profile",
			loginnow: "Login now",
			login_basic: "Login",
			manageDevices: "Manage Devices",
			noActiveSubscription: "No active subscription found",
		},
		devices: {
			title: "My Devices",
			subtitle: "You can have up to {max} active devices",
			noDevices: "You don't have any registered devices",
			deviceId: "Device ID",
			lastActive: "Last active",
			registered: "Registered",
			currentDevice: "Current Device",
			remove: "Remove",
			confirmRemoveTitle: "Confirm Removal",
			confirmRemove: "Are you sure you want to remove this device?",
			confirmRemoveButton: "Remove",
			cancel: "Cancel",
			registerThisDevice: "Register this device",
			deviceLimitReached:
				"You have reached the device limit. Please remove a device to continue watching content on this device.",
		},
		teaser: {
			see_more: "See more",
		},
		search: {
			placeholder: "Search...",
			no_results: "No results found",
			search_with: "Search Results for",
			search_tooltip: "Search",
		},
		innerpage: {
			continue: "CONTINUE",
			play: "PLAY",
			cast: "Cast",
			added: "Added!",
			removed: "Removed!",
			season: "Season ",
			type: "Type",
			movie_characteristics: "Movie characteristics",
			series_characteristics: "Series characteristics",
			more_like_that: "More like that",
			episodes: "Episodes",
			filter_by_season: "Filter by season",
		},
		noConnection: "No internet connection",
		noConnectionDescription: "Please check your connection and try again.",
		promo: {
			title: "Unique movies and series",
			subtitle: "Only 9.90€ per month to watch all our content",
			cancel_anytime: "Cancel anytime",
			start_button: "Start now",
		},
		mobilelogin: {
			loginnow: "Login now to watch content on your mobile",
			enter: "Enter",
		},
		notfound: {
			page_title: "Page Not Found | Valor Movies",
			title: "Page Not Found",
			message: "Sorry, the page you are looking for does not exist or has been moved.",
			back_home: "Back to Home",
		},
		support: {
			title: "Support",
			body: "If you need assistance, please contact our support team at {email}, or reach out to us via the support form.",
		},
		cookieConsent: {
			manageCookies: "Manage Cookies",
		},
	},
}
